function formatDate(date){
    date = new Date(date)
    const opt = {
        "date": date.getFullYear().toString() +'-'+ (date.getMonth() + 1).toString()  +'-'+ date.getDate().toString(),
        "time": date.getHours().toString()  +':'+ date.getMinutes().toString(), 
        'complate':date.getFullYear().toString() +'/'+ (date.getMonth() + 1).toString()  +'/'+ date.getDate().toString()+'/'+ date.getHours().toString()  +'/'+ date.getMinutes().toString()  +'/'+ date.getSeconds().toString(),
        'spriteDate':date.getFullYear().toString() +'-'+ (date.getMonth() + 1).toString()  +'-'+ date.getDate().toString()+' '+ date.getHours().toString()  +':'+ date.getMinutes().toString()  +':'+ date.getSeconds().toString()
    };

    return opt
}

export default formatDate